import React, { createContext, useEffect, useState } from "react";

export const WindowSizeContext = createContext();

export const WindowSizeProvider = ({ children }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <WindowSizeContext.Provider value={{ isMobile }}>
      {children}
    </WindowSizeContext.Provider>
  );
};
